import { omitBy, isEmpty, isNil, map } from 'lodash';
import {decimal, validBoolean, validString, validUUID} from "@dhsn/host/*";

const model = (data: any) => {

  const stockUOMs = map(data.stockUOMs,stockObj => {
    return omitBy({
      uom: stockObj.uom,
      cost: stockObj.cost,
      magnitude: stockObj.magnitude
    },isNil)
  })

  const ProductComponent = omitBy({
    name: data.productName,
    code: data.code,
    type: data.itemType,
    subType: data.itemSubType || null,
    description: data.description,
    productRefCode: data.productRefCode,
    images: data.images || null,
    alias: data.productAlias,
    brand: data.brand,
    categoryID: data.categoryID || null,
    classification: data.classification,
    productCurrency: data.productCurrency,
    baseUOM: omitBy({
      uom: data.baseUOM,
      cost: data.baseUOMCost
    },isNil),
    stockUOMs: stockUOMs.length ? stockUOMs : null,
    displayUOM: data.baseUOM,
  },isNil)

  const PricingList = map(data.pricing,pricingObj => {
    return omitBy({
      pricingID: pricingObj.pricingScheme,
      salesUOM: pricingObj.salesUOM,
      currency: pricingObj.currency,
      value: pricingObj.salesPrice
    },isNil)
  })

  return omitBy({
    _id: data.inventoryID || null,
    orgID: data.orgID,
    product: ProductComponent,
    sku: data.sku,
    lots: data.lots,

    pricing: PricingList.length ? PricingList : null,
    taxSchema: data.taxSchema,
    locationData: data.locationData,

    active: data.active,
    totalBaseStock: data.totalBaseStock,
    currentTotalStock: data.currentTotalStock
  }, isNil);

}

export default model;
